import { captureException } from '@flex-mf/sentry';
import { useAxios, getQueryKey } from '@flex-packages/remote-hooks';
import { useQueryClient } from '@tanstack/react-query';
import '../../apis/workspace/apis/workspace-customer-controller-api.mjs';
import { getMyWorkspaceUsersRemote } from '../../apis/workspace/apis/workspace-user-controller-api.mjs';
import '../../apis/workspace/apis/workspace-user-customer-controller-api.mjs';
import useMyUserInfo from './useMyUserInfo.mjs';

const useCurrentUser = (options) => {
  const queryClient = useQueryClient();
  const { instances } = useAxios();
  const [, defaultConfig] = getMyWorkspaceUsersRemote(instances.json);
  const { data, ...rest } = useMyUserInfo(options);
  const getCurrentUser = () => {
    try {
      return data?.currentUser.user;
    } catch (error) {
      captureException("[useCurrentUser]: data.currentUser is undefined.", {
        level: "error",
        extra: {
          queryData: queryClient.getQueryData(getQueryKey(defaultConfig)),
          podoInitialData: window.PODO_INITIAL_DATA
        }
      });
      throw error;
    }
  };
  return {
    data: getCurrentUser(),
    ...rest
  };
};

export { useCurrentUser as default };
//# sourceMappingURL=useCurrentUser.mjs.map
